import { Button } from '@/common/components/Button'
import { SuccessCircleIcon } from '@/common/icons/general'
import { resetReimbursementData } from '@/storage/applications/reimubrusementSlice'
import { useTranslation } from 'react-i18next'
import { useDispatch } from 'react-redux'

export const ReimbursementApplicationSent = () => {
  const { t: translate } = useTranslation()
  const dispatch = useDispatch()

  return (
    <>
      <div className="flex flex-col items-center justify-center mt-6 min-h-[40vh]">
        {/* Check Icon */}
        <SuccessCircleIcon />
        <h3 className="text-xl font-medium text-gray-900 mt-3">
          {translate('application_submitted')}
        </h3>
        <p className="text-sm text-center text-gray-900 mt-6">
          {translate('reimbursements_application_submitted')}
        </p>
      </div>
      <div className="text-center h-full flex mt-6">
        <div className="flex justify-end mb-5 w-full flex-col">
          <Button
            onClick={() => {
              dispatch(resetReimbursementData())  
            }}
            className="rounded h-9 mb-5"
          >
            {translate('continue')}
          </Button>
        </div>
      </div>
    </>
  )
}
